export default "__VITE_ASSET__btjWFhEU__"